module.exports = __webpack_public_path__ + "static/07.02.03.discover.trending-42e7dde4212ec0efc06112b0ad226ab3.png";